/* eslint-disable no-unused-vars */
import React, { createRef, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  FormControlLabel,
  Checkbox,
  Card,
  CardContent,
  TextField,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  accordion: {
    "&:before": {
      display: "none",
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  isValid: {
    color: "#058C46 !important",
    backgroundColor: "#CDFFE4 !important",
  },
  inProgress: {
    color: "#A7A004 !important",
    backgroundColor: "#FFFDC8 !important",
    fontWeight: "bold !important",
  },
  btnBack: {
    color: "#fff ",
    backgroundColor: "#A7A5A5 ",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2),
  },
  tbHeader: {
    backgroundColor: "#0A91F3",
    color: "#fff !important",
    fontWeight: "bold !important",
  },
  tbHideColumn: {
    width: 0,
    visibility: 'hidden',
  },
  inputNumHideArrow: {
    '& input[type=number]': {
        '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    }
}
}));

const min = 0;
const max = 4;

function SiteVisitQuestionSet({
  data,
  isViewMode,
  onComplete,
  className,
  ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const summayAverageScore = () => {
    return ((!!data.isWeightChecked && data.sections) || [])
      .reduce(
        (sum, section) => sum + (+section.weight * +section.totalScore) / 100,
        0
      )
      .toFixed(2);
  };
  const handleWeightTextChange = (event, sectionId) => {
    data.sections = data.sections.map((section) => {
      if (section.sectionID === sectionId) {
        section.weight = event.target.value;
        section.scoreWeight = section.totalScore * event.target.value;
      }
      return section;
    });
    onComplete(Object.assign({}, data));
  };

  const handleTotalWeightTextChange = (event) => {
    data.weight = event.target.value;
    onComplete(Object.assign({}, data));
  };

  const handleTotalScoreTextChange = (event, sectionId) => {
    data.sections = data.sections.map((section) => {
      if (section.sectionID === sectionId) {
        section.totalScore = event.target.value;
        section.scoreWeight = section.weight * event.target.value;
      }
      return section;
    });
    onComplete(Object.assign({}, data));
  };

  const handleSumTotalScoreTextChange = (event) => {
    data.totalScore = event.target.value;
    onComplete(Object.assign({}, data));
  };

  const handleWeightCheckboxChange = (event) => {
    data.isWeightChecked = !!event.target.checked;
    onComplete(Object.assign({}, data));
  };

  return (
    <Card variant="outlined" className={classes.root}>
      <CardContent>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className={classes.tbHeader}>{t("vendorSite.topic")}</TableCell>
                <TableCell className={classes.tbHeader} align="center">
                {t("vendorSite.fullScore")}
                </TableCell>
                {/* <TableCell className={classes.tbHeader} align="center">
                  คะแนน Self assessment
                </TableCell> */}
                <TableCell className={classes.tbHeader}></TableCell>
                {/* <TableCell className={classes.tbHideColumn} align="center">
                  <FormControlLabel
                    className={classes.tbHideColumn}
                    control={
                      <Checkbox className={classes.tbHideColumn}
                        style={{
                          color: "#fff",
                        }}
                        disabled={isViewMode}
                        checked={!!data.isWeightChecked}
                        onChange={handleWeightCheckboxChange}
                      />
                    }
                  />
                  น้ำหนัก Weight %
                </TableCell> */}
                <TableCell className={classes.tbHeader}></TableCell>
                <TableCell className={classes.tbHeader} align="center">
                {t("vendorSite.score")}
                </TableCell>
                {/* <TableCell className={classes.tbHeader} align="center">
                  คะแนน site visit X Weight %
                </TableCell> */}
                <TableCell className={classes.tbHeader}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.sections &&
                data.sections.map((section, i) => (
                  <TableRow
                    key={section.sectionID}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {section.sectionCode + "  " + section.nameTH}
                    </TableCell>
                    <TableCell align="center">{section?.fullScore}</TableCell>
                    <TableCell className={classes.tbHideColumn} align="center">
                      {section?.selfAssessmentScore
                        ? parseFloat(section?.selfAssessmentScore || 0).toFixed(
                            2
                          )
                        : "-"}
                    </TableCell>
                    <TableCell className={classes.tbHideColumn} align="center">
                      <TextField
                        disabled={isViewMode || !!!data.isWeightChecked}
                        size="small"
                        type="number"
                        sx={{ width: "40%" }}
                        value={(section.weight || "").toString() || ""}
                        onChange={(e) =>
                          handleWeightTextChange(e, section.sectionID)
                        }
                      ></TextField>
                    </TableCell>
                    <TableCell className={classes.inputNumHideArrow} align="center">
                      <TextField
                        disabled={isViewMode}
                        size="small"
                        type="number"
                        inputProps={{ min, max }}
                        sx={{ width: "40%" }}
                        value={(section?.totalScore || "").toString() || ""}
                        onChange={(e) => {
                            const value = +e.target.value;
                            if (value > max)
                              return;
                            else if (value < min)
                              return;

                            handleTotalScoreTextChange(e, section.sectionID)
                          }
                        }
                      ></TextField>
                    </TableCell>
                    <TableCell className={classes.tbHideColumn} align="center">
                      {(!!data?.isWeightChecked &&
                        (section?.weight * section?.totalScore) / 100) ||
                        "-"}
                    </TableCell>
                  </TableRow>
                ))}
              <TableRow
                sx={{
                  "&:last-child td, &:last-child th": {
                    border: 0,
                  },
                }}
              >
                <TableCell align="right">คะแนนรวม</TableCell>
                <TableCell align="center">4</TableCell>
                <TableCell className={classes.tbHideColumn} align="center">
                  {data?.selfAssessmentScore || "-"}
                </TableCell>
                <TableCell className={classes.tbHideColumn} align="center">
                  <TextField
                    disabled={isViewMode || !!!data.isWeightChecked}
                    size="small"
                    type="number"
                    sx={{ width: "40%" }}
                    value={(data.weight || "").toString() || ""}
                    onChange={handleTotalWeightTextChange}
                  ></TextField>
                </TableCell>
                <TableCell align="center">
                  <TextField className={classes.inputNumHideArrow}
                    disabled={isViewMode}
                    size="small"
                    type="number"
                    inputProps={{ min, max }}
                    sx={{ width: "40%" }}
                    value={(data?.totalScore || "").toString() || ""}
                    onChange={(e) => {
                      const value = +e.target.value;
                        if (value > max)
                          return;
                        else if (value < min)
                          return;

                      handleSumTotalScoreTextChange(e)
                    }}
                  ></TextField>
                </TableCell>
                <TableCell className={classes.tbHideColumn} align="center">
                  {summayAverageScore() > 0 ? summayAverageScore() : "-"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}

SiteVisitQuestionSet.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
};

export default SiteVisitQuestionSet;
